import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearAlert } from '../store/slices/alertSlice';

const Alert = () => {
  const { message, type } = useSelector((state) => state.alert);
  const dispatch = useDispatch();

  useEffect(() => {
    if (message) {
      // Auto-hide the alert after 5 seconds
      const timer = setTimeout(() => {
        dispatch(clearAlert());
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [message, dispatch]);

  if (!message) return null;

  // Define a more polished color scheme
  const alertStyles = {
    success: {
      background: 'linear-gradient(135deg, #28a745, #218838)',
      color: '#fff',
      border: '1px solid #155724',
    },
    danger: {
      background: 'linear-gradient(135deg, #dc3545, #c82333)',
      color: '#fff',
      border: '1px solid #721c24',
    },
    info: {
      background: 'linear-gradient(135deg, #17a2b8, #138496)',
      color: '#fff',
      border: '1px solid #117a8b',
    }
  };

  const alertColor = alertStyles[type] || alertStyles.info;

  const handleAlertClick = () => {
    // Hide the alert when clicked
    dispatch(clearAlert());
  };

  return (
    <div
      className="alert-container"
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        maxWidth: '400px',
        minWidth: '250px',
        width: 'auto',
        borderRadius: '8px',
        padding: '10px 15px',
      }}
    >
      <div
        className={`alert fade show`}
        role="alert"
        style={{
          background: alertColor.background,
          color: alertColor.color,
          border: alertColor.border,
          padding: '20px 25px', // Increased padding for better space
          marginBottom: '10px',
          borderRadius: '8px',
          fontFamily: 'Arial, sans-serif',
          fontSize: '16px', // Increased font size for better readability
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer', // Make it clickable
        }}
        onClick={handleAlertClick} // Hide alert on click
      >
        <div>
          <strong>{type === 'danger' ? 'Error!' : type === 'success' ? 'Success' : 'Info'}</strong> {message}
        </div>
      </div>
    </div>
  );
};

export default Alert;
